const DEFAULT_IMAGE_PATHS = {
  doctor: "uploads/doctor/placeholder.png",
  hospital: "uploads/doctor/placeholder.png",
  department: "uploads/lab_category/1786968203785blood tests.jpg",
  lab: "uploads/lab/1786967638399RapidmediK Final logo (1).jpg",
  package: "uploads/lab_category/1786968203785blood tests.jpg",
  banner: "uploads/lab/1786967638399RapidmediK Final logo (1).jpg",
  patient: "uploads/doctor/placeholder.png",
  payment: "uploads/payment_image/1787222464576cashfreeLogo.png",
  default: "uploads/doctor/placeholder.png",
};

function normalizeBaseUrl(baseUrl) {
  return String(baseUrl || "https://portal.rapidmedik.com/").endsWith("/")
    ? String(baseUrl || "https://portal.rapidmedik.com/")
    : `${baseUrl}/`;
}

function encodeImagePath(imagePath) {
  return String(imagePath)
    .replace(/^\/+/, "")
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/");
}

export function getFallbackImage(baseUrl, kind = "default") {
  const normalizedBase = normalizeBaseUrl(baseUrl);
  const fallbackPath = DEFAULT_IMAGE_PATHS[kind] || DEFAULT_IMAGE_PATHS.default;
  return `${normalizedBase}${encodeImagePath(fallbackPath)}`;
}

export function buildImageUrl(baseUrl, imagePath, kind = "default") {
  if (typeof imagePath === "string" && /^https?:\/\//i.test(imagePath)) {
    return imagePath;
  }

  if (typeof imagePath === "string" && imagePath.trim() !== "") {
    return `${normalizeBaseUrl(baseUrl)}${encodeImagePath(imagePath.trim())}`;
  }

  return getFallbackImage(baseUrl, kind);
}

export function applyImageFallback(event, baseUrl, kind = "default") {
  const fallbackSrc = getFallbackImage(baseUrl, kind);

  if (event?.currentTarget && event.currentTarget.src !== fallbackSrc) {
    event.currentTarget.src = fallbackSrc;
  }
}
